import { useFragment } from '$contentful-gql/fragment-masking';
import { textFragment } from '$providers/common';
import cn from 'classnames';
import { HTMLAttributes } from 'react';

import { ITimelineContent } from './';

export function TimelineContent(
  props: ITimelineContent & HTMLAttributes<HTMLElement>,
) {
  const { item, right } = props;

  const itemText = useFragment(textFragment, item);

  return (
    <div
      className={cn(
        'h-full flex flex-col justify-center items-start md:items-center -mt-[10px] md:mt-0',
      )}
    >
      <div
        className={cn(
          right ? 'md:items-end' : 'md:items-start',
          'flex flex-col md:w-3/4 md:mb-0 pl-12 md:pl-0',
        )}
      >
        {itemText.subtitle && (
          <time
            className={cn(
              'style-heading-xxxs text-50',
              right ? 'md:text-right' : '',
            )}
            dateTime="2008-02-14 20:00"
          >
            {itemText.subtitle}
          </time>
        )}
        {itemText.title && (
          <h3 className={cn('style-heading-xxs text-grey-80')}>
            {itemText.title}
          </h3>
        )}
      </div>
    </div>
  );
}
